import { IsBoolean, IsOptional, IsString, IsUUID } from "class-validator";

/**
 * Shared contract dto between frontend and backend.
 */
export class UserDto {
  @IsString()
  oktaId!: string;

  @IsString()
  @IsOptional()
  country?: string;

  @IsString()
  @IsOptional()
  language?: string;

  @IsString()
  @IsOptional()
  email?: string;

  @IsOptional()
  @IsUUID()
  id?: string;

  @IsString()
  @IsOptional()
  productFruitsHmac?: string;

  @IsBoolean()
  @IsOptional()
  showZrefPrices?: boolean;
}
